<template>
  <custom-modal v-if="showDialog" modal-width="25rem" body-padding="0 24px 0px" @close="closeModal">
    <template #header>
      {{ editMode ? $t("contextMenu.changeRole") : $t("contextMenu.addMember") }}
    </template>
    <template #body>
      <form @submit.prevent="submit">
        <custom-input
          :value="email"
          type="email"
          :label="$t('contextMenu.Email')"
          :mode="editMode"
          @input="email = $event"
        ></custom-input>
        <span class="user-role">Role</span>
        <select-box :value="role" :options="availableRoles" @input="role = $event"> </select-box>
        <div class="kk-memberdialog__btns">
          <custom-button button-class="btn btn-default btn-primary" button-type="submit">
            {{ editMode ? $t("contextMenu.update") : $t("views.add") }}
          </custom-button>
          <custom-button button-class="btn btn-default" button-type="button" @click="closeModal">
            {{ $t("actions.cancel") }}</custom-button
          >
        </div>
      </form>
    </template>
    <template #footer>
      <span></span>
    </template>
  </custom-modal>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes, permissionLevels, TreeDefaultNodeIds } from "../../../../utils/constants";
import CustomButton from "../../../commons/CustomButton.vue";
import CustomModal from "../../../commons/CustomModal.vue";
import CustomInput from "../../../commons/CustomInput.vue";
import SelectBox from "../../../commons/SelectBox.vue";
import { authorizationHelper } from "../../../../store/helpers/AuthorizationHelper";
export default {
  components: {
    CustomButton,
    CustomModal,
    CustomInput,
    SelectBox,
  },
  data() {
    return {
      email: "",
      role: "VIEWER",
      roleItems: [
        { text: "VIEWER", value: "VIEWER", icon: "icon-account-eye" },
        { text: "EDITOR", value: "EDITOR", icon: "icon-account-edit" },
        { text: "COMMENTOR", value: "COMMENTOR", icon: "icon-comment-edit-outline" },
        { text: "MANAGER", value: "MANAGER", icon: "icon-share-2" },
        { text: "ADMIN", value: "ADMIN", icon: "icon-account-cog" },
      ],
      previousScope: null,
      currentPermission: "VIEWER",
    };
  },
  computed: {
    itemId() {
      return this.$store.state.teams.addMemberDialog.id;
    },
    showDialog: {
      get() {
        return this.$store.state.teams.addMemberDialog.show;
      },
      set(newValue) {
        return this.$store.dispatch("teams/setAddMemberDialog", { show: newValue });
      },
    },
    editMode() {
      return this.$store.state.teams.addMemberDialog.editMode;
    },
    member() {
      return this.$store.getters["teams/getItemById"](this.itemId);
    },
    availableRoles() {
      return this.roleItems.filter((role) => permissionLevels[role.value] <= permissionLevels[this.currentPermission]);
    },
  },
  watch: {
    showDialog(newVal, oldVal) {
      if (newVal) {
        this.previousScope = hotkeys.getScope();
        this.$store.dispatch("setScope", HotkeyScopes.AddMemberDialog);
        if (this.editMode) {
          this.email = this.member.email;
          this.role = this.member.type;
        }
        this.initialize();
      } else {
        this.$store.dispatch("setScope", this.previousScope);
      }
    },
  },
  methods: {
    async initialize() {
      const permissionHelper = authorizationHelper(this.$store.dispatch, this.$store.state);

      let teamId = this.member.parents[this.member.parents.length - 1];
      if (teamId === undefined || teamId === TreeDefaultNodeIds.Root) {
        teamId = this.member.id;
      }
      const permossions = await permissionHelper.getTeamBasedPermission(teamId);
      this.currentPermission = permossions.role;
    },
    closeModal() {
      this.showDialog = !this.showDialog;
    },
    submit() {
      if (!this.editMode)
        return this.$store.dispatch("teams/addMember", { teamId: this.itemId, email: this.email, role: this.role });
      if (this.role === this.member.type) return (this.showDialog = false);

      const teamId = this.member.parents[this.member.parents.length - 1];
      this.$store.dispatch("teams/changeRole", { teamId, memberId: this.itemId, role: this.role });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/variables";

.user-role {
  display: block;
  margin-top: 8px;
}

.kk-memberdialog {
  &__btns {
    display: flex;
    gap: 10px;
    padding-top: 1rem;
    justify-content: right;
  }
}
</style>
